
import { ReactNode, ButtonHTMLAttributes } from 'react';
import { cn } from "@/lib/utils";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'outline' | 'text';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  animate?: boolean;
}

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  animate = false,
  className,
  ...props
}: ButtonProps) => {
  const baseStyles = "rounded-md font-medium transition-all flex items-center justify-center shadow-sm";
  
  const variantStyles = {
    primary: "bg-omoduduwa-terracotta hover:bg-omoduduwa-terracotta/90 text-white",
    outline: "border-2 border-omoduduwa-terracotta text-omoduduwa-indigo hover:bg-omoduduwa-terracotta hover:text-white",
    text: "text-omoduduwa-indigo hover:text-omoduduwa-terracotta"
  };
  
  const sizeStyles = {
    sm: "py-1.5 px-4 text-sm",
    md: "py-2.5 px-6 text-base",
    lg: "py-3 px-8 text-lg"
  };
  
  const widthStyle = fullWidth ? "w-full" : "";
  const animationStyle = animate ? "hover:animate-pulse-gentle" : "";
  
  return (
    <button
      className={cn(
        baseStyles,
        variantStyles[variant],
        sizeStyles[size],
        widthStyle,
        animationStyle,
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
